module.exports = __webpack_public_path__ + "static/media/payment_mode.9b5d05d7.png";